import { gql } from 'apollo-boost'

const MARK_DISH_REVIEW_TASK_AS_AWAITING = gql`
  mutation markDishReviewTaskAsAwaiting(
    $id: ID!
    $awaitingReason: TaskAwaitingReason!
    $awaitingReasonComment: String
  ) {
    markDishReviewTaskAsAwaiting(
      id: $id
      awaitingReason: $awaitingReason
      awaitingReasonComment: $awaitingReasonComment
    ) {
      id
      awaitingReason
      awaitingReasonComment
      modifiedDate
    }
  }
`

export default MARK_DISH_REVIEW_TASK_AS_AWAITING
